export const IMG_CDN_URL: string =
  "https://res.cloudinary.com/swiggy/image/upload/fl_lossy,f_auto,q_auto,w_508,h_320,c_fill/";
export const FETCH_MENU_URL: string =
  "https://www.swiggy.com/dapi/menu/v4/full?lat=12.9351929&lng=77.62448069999999&menuId=";
export const FETCH_ALL_RESTAURANTS: string =
  "https://www.swiggy.com/dapi/restaurants/list/v5?lat=12.9351929&lng=77.62448069999999&page_type=DESKTOP_WEB_LISTING";
export const SHIMMER_IMAGE_URL: string =
  "https://htmlcolorcodes.com/assets/images/colors/light-gray-color-solid-background-1920x1080.png";
export const NO_IMAGE_AVAILABLE: string =
  "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSvHdRZDerGbZ57-ps_PwHdfI90X4p1sr8I4w&usqp=CAU";
